import * as React from 'react';
import { UserState } from 'app/reducers/state';
import moment from 'moment';
import { each, filter, clone } from 'lodash';
import { Callout, Intent, Tabs, Tab, Button, TextArea, PopoverInteractionKind, Popover, H5, Icon, TabId, Spinner, H2, H4, Card, Elevation } from '@blueprintjs/core';
import { API_CHARTBACK, executeQueryPostAuth } from 'app/utils/api';
import * as superagent from 'superagent';

interface GameData {
    postFeedback: string;
    preFeedback: string;
    userID: string;
    objectives: GameDataObjective[];
    submitted: string;
    "game-id": string;
    scenario: string;
    results: string;
}

interface GameDataObjective {
    academicDescription: string;
    category: string;
    description: string;
    name: string;
    result: string;
    submitted: string;
}

interface Props {
    user: UserState;
    selectedGame: GameData;
    canEditJournal?: boolean;
    inSimulator?: boolean;
    title: string;
    updateJournalDataInline: (stage: string, payload: string, gameID: string) => void;
    readyToRender?: () => void;
    hasSeenAllCategories?: () => void; // Optional hook that tells the parent component, when the viewer has looked at all
                                       // the categories
    customWarningStyle?: any;
    hideScore?: boolean;
    updateJournalDataInlineAndContinue?: any;
};

function BASESCENARIOFROMNAME(scenario: string) {
    if (scenario.includes('scenario_2')) return 'scenario_2';
    if (scenario.includes('scenario_3')) return 'scenario_3';
    if (scenario.includes('scenario_4')) return 'scenario_4';
    if (scenario.includes('scenario_5')) return 'scenario_5';

    return 'scenario_1';
}

interface State {
    showPreAppend: boolean;
    showPostAppend: boolean;
    preAppendContent: string;
    postAppendContent: string;
    loadingAppendData: boolean;
    categorySeenMap: {};
    constructiveData: any;
    loadingConstructive: boolean;
}

export class 
KryPlayDetails2 extends React.Component<Props, State> {

    state: State = {
        showPostAppend: false,
        showPreAppend: false,
        loadingAppendData: false,
        preAppendContent: "",
        postAppendContent: "",
        categorySeenMap: {},
        constructiveData: {},
        loadingConstructive: true
    }

    componentDidMount() {
        // Mark the default tab as seen
        const categories = this.getAllCategories();
        const defaultTab = categories && categories.length > 0 ? "tb_single_" + categories[0] : undefined;
        this.markCategorySeen(defaultTab);

        this.dataCert(this.props.selectedGame['game-id']);
    }

    dataCert = (gameID: string) => {
        this.setState({
            loadingConstructive: true
        });

        superagent.
            get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + gameID + "&authenticationToken=" + this.props.user.authenticationToken + "&baseScenario=" + BASESCENARIOFROMNAME(this.props.selectedGame.scenario)).
            end((error:any, response:any) => {
                const b = JSON.parse(response.text);

                this.setState({
                    constructiveData: b,
                    loadingConstructive: false
                });
        });
    }

    markCategorySeen = (title) => {
        let newCategorySeenMap = clone(this.state.categorySeenMap);

        newCategorySeenMap[title] = 1;

        let newSeenTotal  = Object.keys(newCategorySeenMap).length;
        let goalSeenTotal = this.getAllCategories().length;

        // Check for our has seen all categories hook
        if (newSeenTotal >= goalSeenTotal) {
            if (this.props.hasSeenAllCategories) {
                this.props.hasSeenAllCategories();
            }
        }

        this.setState({
            categorySeenMap: newCategorySeenMap
        });
    }

    getAllCategories = () => {
        const {
            selectedGame
        } = this.props;

        let uniqueCategoryNames: string[] = [];

        each(selectedGame.objectives, objective => {
            if (!uniqueCategoryNames.includes(objective.category)) {
                uniqueCategoryNames.push(objective.category)
            }
        });

        return uniqueCategoryNames.sort();
    }

    getAllEntriesForACategory = (category: string) => {
        const {
            selectedGame
        } = this.props;

        return filter(selectedGame.objectives, objective => {
            return objective.category === category;
        });
    }

    getPreFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.preFeedback === "" || selectedGame.preFeedback === "None" || selectedGame.preFeedback === undefined) {
            return "Not Entered";
        }

        return selectedGame.preFeedback;
    }

    getPostFeedback = () => {
        const {
            selectedGame
        } = this.props;

        if (selectedGame.postFeedback === "" || selectedGame.postFeedback === "None" || selectedGame.postFeedback === undefined) {
            return "Not Entered";
        }

        return selectedGame.postFeedback;
    }

    getCanEditJouranl = () => {
        const {
            canEditJournal,
        } = this.props;

        const {
            showPostAppend,
            showPreAppend
        } = this.state;

        if (showPreAppend) {
            return false;
        }

        if (showPostAppend) {
            return false;
        }

        if (canEditJournal === true) {
            return true;
        }

        return false;
    }

    convertScenarioToFullName = (scenario: string) => {
        if (scenario === 'scenario_1') {
            return "Module 2 Explore";
        }

        if (scenario === 'scenario_1_assess') {
            return "Module 2 Assess";
        }

        if (scenario === 'scenario_1_a1') {
            return "Lesson 1";
        }

        if (scenario === 'scenario_1_a2') {
            return "Lesson 2";
        }

        if (scenario === 'scenario_1_a3') {
            return "Lesson 3";
        }
    }

    getCurrentRound = () => {
        const {
            selectedGame
        } = this.props;

        return parseInt(selectedGame['total-rounds']);
    }

    getPanelTitle = (): any => {
        const {
            selectedGame
        } = this.props;

        return <span>
            <span>
                {this.convertScenarioToFullName(selectedGame!.scenario)}
            </span>
            <span style={{float: 'right', fontSize: '15px'}}>
                Rounds: {this.getCurrentRound()}
            </span>
        </span>
    }

    renderCategoryPanel = (category: any) => {
        const categoryEntries = this.getAllEntriesForACategory(category);

        let entries: JSX.Element[] = [];

        each(categoryEntries, (entry) => {
            const isSuccessfull = entry.result === "True" || entry.result === "true";

            entries.push(
                <Popover 
                    interactionKind={PopoverInteractionKind.HOVER}
                    boundary={"viewport"}
                    modifiers={
                        {
                            arrow: {enabled: true},
                            preventOverflow: { enabled: true }
                        }
                    }
                >
                    <Callout className={"single-view-callout " + (isSuccessfull ? "callout-green-icon" : "callout-red-icon")} icon={isSuccessfull ? "tick" : "minus"} title={entry.name}>
                        {entry.description}
                    </Callout>
                    <div style={{maxWidth: '400px', padding: '10px', display: 'block'}}>
                        <H5>How To Achieve</H5>
                        {entry.academicDescription}
                    </div>
                </Popover>
            )
        });

        return <span style={{width: '100%'}}>
            {entries}
        </span>
    }

    renderCategorySelection = () => {
        const categories = this.getAllCategories();

        let categoryMenu: JSX.Element[] = [];

        each(categories, category => {
            const categoryEntries = this.getAllEntriesForACategory(category);
            const categoryTotal = categoryEntries.length;
            const categorySuccess = filter(categoryEntries, (entry:GameDataObjective) => { return entry.result === "True"}).length;

            const menuLabel = "(" + categorySuccess.toString() + "/" + categoryTotal.toString() + ") " + category;

            categoryMenu.push(
                <Tab id={"tb_single_" + category} title={menuLabel} panel={this.renderCategoryPanel(category)} />
            );
        });

        const defaultTab = categories && categories.length > 0 ? "tb_single_" + categories[0] : undefined;

        return <span className="bold-tab-menu">
            <Tabs
                animate={true}
                defaultSelectedTabId={defaultTab}
                id="single_score_objective_view"
                key={"horizontal"}
                renderActiveTabPanelOnly={false}
                onChange={(navbarTabId: TabId) => {
                    // Mark it seen when the tab changes
                    this.markCategorySeen(navbarTabId);
                }}
                vertical={true}
            >
                {categoryMenu}
            </Tabs>
        </span>
    }

    updateFeedbackContent = (stage: string, feedback: string) => {
        this.setState({
            showPostAppend: false,
            showPreAppend: false,
            loadingAppendData: true,
            preAppendContent: "",
            postAppendContent: ""
        });

        const queryBase = "data/feedback/" + stage + "/" + this.props.selectedGame["game-id"];

        const existingContent = (stage === "pre") ? this.getPreFeedback() : this.getPostFeedback();

        const newPayload = existingContent + "\r\n" + moment().format("LLLL") + "\r\n" + feedback;

        executeQueryPostAuth(queryBase, {
            feedback: newPayload
        }, this.props.user, () => {
            // Refresh the page now

            this.props.updateJournalDataInline(stage, newPayload, this.props.selectedGame["game-id"]);

            this.setState({
                loadingAppendData: false
            });
        });
    }

    renderPreAppend = () => {
        const {
            showPreAppend,
            preAppendContent
        } = this.state;

        if (!showPreAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{width: '100%', marginBottom: '5px'}}
                onChange={(event) => {
                    this.setState({
                        preAppendContent: event.target.value
                    });
                }}
                value={preAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("pre", preAppendContent);
            }, Intent.SUCCESS, "Save")}
        </span>
    }
    
    renderPostAppend = () => {
        const {
            showPostAppend,
            postAppendContent
        } = this.state;

        if (!showPostAppend) return undefined;

        return <span>
            <TextArea
                growVertically={true}
                large={true}
                intent={Intent.PRIMARY}
                style={{width: '100%', marginBottom: '5px'}}
                onChange={(event) => {
                    this.setState({
                        postAppendContent: event.target.value
                    });
                }}
                value={postAppendContent}
            />
            {this.renderNormalButton("", () => {
                this.updateFeedbackContent("post", postAppendContent);
            }, Intent.SUCCESS, "Save")}
        </span>
    }

    renderNormalButton = (rightIcon: any, onClick: any, intent: any, text: string) => {
		return <Button style={{margin: '0px', width: '100%'}} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={text} />
    }
    
    renderCardToRollover() {
        const {
            customWarningStyle
        } = this.props;

        if (customWarningStyle === undefined) {
            return <span className="badgeForMoreInfo">
                <Icon style={{marginRight: '5px'}} icon="info-sign" />Try Hovering Over Objectives For More Info
            </span>
        }

        return <span style={customWarningStyle} className="badgeForMoreInfo">
            <Icon style={{marginRight: '5px'}} icon="info-sign" />Try Hovering Over Objectives For More Info
        </span>
    }

    getConfigInfo = (config: string, scenario: string, name: string) => {
        let response: any = undefined;

        const lines = config.split('\n');

        for (let i = 0; i < lines.length; i++) {
            const bits = lines[i].split('\t');

            try {
                if (bits[0] === scenario) {
                    if (bits[4] === name) {
                        const difficulty = parseInt(bits[5]);
                        const score      = parseInt(bits[5]);
                        const successA   = bits[8];
                        const failA      = bits[9];

                        response = { difficulty, score, successA, failA };
                    }
                }
            }
            catch(e) {}
        }

        return response;
    }

    getPositionedAdjectives = (_data: any[], max: number, direction: number, nameMatch: string) => {
        let data: any[] = [];

        if (nameMatch === undefined) {
            data = _data;
        }
        else {
            for (let i = 0; i < _data.length; i++) {
                const name: string = _data[i].name;

                if (name.toLowerCase().includes(nameMatch.toLowerCase())) {
                    data.push(_data[i]);
                }
            }
        }

        if (data.length <= max) {
            let buffer2: any = [];

            for (let i = 0; i < data.length; i++) {
                buffer2.push(<li>{data[i].adjective}</li>);
            }

            return buffer2;
        }

        let buffer: any = [];

        for (let i = 0; i < max; i++) {
            // Do we count from the start of the array, or the back?
            const index = direction === 1 ? i : data.length - 1 - i;

            buffer.push(<li>{data[index].adjective}</li>);
        }

        if (direction === 1 && buffer.length === 0) {
            return <span>{"There wasn’t much more you could have done to be more directive"}</span>
        }

        return buffer;
    }

    convertScenarioToX = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 1;
        if (scenario === 'scenario_1_a2') return 2;
        if (scenario === 'scenario_1_a3') return 3;

        // Fallback to directive if we can't figure it out
        return 1;
    }

    convertScenarioToStyle = (scenarioName: string) => {
        const scenario = scenarioName.toLowerCase();

        if (scenario === 'scenario_1_a1') return 'Directive';
        if (scenario === 'scenario_1_a2') return 'Delegative';
        if (scenario === 'scenario_1_a3') return 'Participative';

        // Fallback to directive if we can't figure it out
        return 'Directive';
    }

    // Easiest, because the lowest difficulty objectives are at the top
    getTopAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, 1, nameMatch);
    }

    // Hardest because the highest difficulty objectives are at the bottom
    getBottomAdjectives = (data: any, max: number, nameMatch: any) => {
        return this.getPositionedAdjectives(data, max, -1, nameMatch);
    }

    getHighestStyle = () => {
        const {
            loadingConstructive
        } = this.state;

        if (loadingConstructive === false) {
            const intendedStyle = this.getCurrentShorthand().toLowerCase();

            return intendedStyle;
        }

        return '';
    }

    getHighestScore = () => {
        const {
            constructiveData,
            loadingConstructive
        } = this.state;

        if (loadingConstructive === false) {
            try {
                return parseFloat(constructiveData.coaching[this.props.selectedGame.scenario].final);
            }
            catch(e) {
                return '';
            }
        }

        return '';
    }

    getIsIntendedStyleMatching = () => {
        //@ts-ignore
        return this.getHighestScore() > 50.0;
    }

    getSectionFromSheet2 = (configStatement: string, x: number, y: number) => {
        const lines: any[] = configStatement.split('\n');

        if (lines.length <= y) {
            return '';
        }

        const targetLine = lines[y];
        const bits = targetLine.split('\t');

        if (bits.length <= x) {
            return '';
        }

        return bits[x];
    }

    renderSimulatedSection = (data: any, scenario: string) => {
        // let cScore      = 0.0;
        // let cTotalScore = 0.0;

        // let successObjectives: any[] = [];
        // let failedObjectives: any[] = [];

        // each(data.objectives, objective => {
        //     const objectivename = objective.name;
        //     const isSuccessfull = objective.result === "True" || objective.result === "true";

        //     const configInfo = this.getConfigInfo(config, scenario, objectivename);

        //     if (configInfo !== undefined) {
        //         const difficulty = parseInt(configInfo.difficulty);
        //         const score      = parseInt(configInfo.score);

        //         cTotalScore += score;
        //         if (isSuccessfull) { 
        //             cScore += score;

        //             successObjectives.push(
        //                 {
        //                     name: objectivename,
        //                     difficulty,
        //                     adjective: configInfo.successA
        //                 }
        //             );
        //         }
        //         else {
        //             failedObjectives.push(
        //                 {
        //                     name: objectivename,
        //                     difficulty,
        //                     adjective: configInfo.failA
        //                 }
        //             );
        //         }
        //     }
        // });

        // // Sort each of our objective sets
        // successObjectives.sort((a,b) => a.difficulty - b.difficulty);
        // failedObjectives.sort((a,b) => a.difficulty - b.difficulty);

        // if (cTotalScore === 0.0) cTotalScore = 1.0;

        // const fScore = cScore / cTotalScore * 100.0;
        // const final = Math.round(fScore);

        const final = data.final;
        const successObjectives = data.successObjectives;
        const failedObjectives = data.failedObjectives;

        // Construct the successMessage
        //let successTemplate = 'Looking at how you played, you were <adjective triggered by percentage> <style name>. You were <2 hardest process objectives achieved> which helped you <list of outcome objectives achieved>.<Statement about style when successful>. <Statement about connections to chart>.<Statement about learner growth from this successful experience>';
        //let failureTemplate = 'Looking at how you played, you were not very <style name>. You did manage to <List of 2 hardest objectives Achieved> but you <list of 3 easiest unachieved objectives>.<Statement of how to achieve style which is also the plan> <Statement about style when you fail>.<Statement about learner growth from this unsuccessful experience>. Maybe try this again using some of my advice?';

        const topAchieved = this.getBottomAdjectives(successObjectives, 3, undefined);
        const notAchieved = this.getTopAdjectives(failedObjectives, 3, undefined);
        
        const message = <div>
            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What Went Well</h5>
                <ul>
                    {topAchieved}
                </ul>
            </Card>

            <Card interactive={false} elevation={Elevation.ZERO}>
                <h5>What To Try Next Time</h5>
                <ul>
                    {notAchieved}
                </ul>
            </Card>
        </div>

            // const successMessage = successTemplate
            //     .replace('<adjective triggered by percentage>', '')
            //     .replace('<style name>', this.convertScenarioToStyle(scenario))
            //     .replace('<2 hardest process objectives achieved>', this.getBottomAdjectives(successObjectives, 2, "process"))
            //     .replace('<list of outcome objectives achieved>', this.getTopAdjectives(successObjectives, 10, "outcome"))
            //     .replace('<Statement about style when successful>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 2))
            //     .replace('<Statement about connections to chart>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 3))
            //     .replace('<Statement about learner growth from this successful experience>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 4));

            // const failureMessage = failureTemplate
            //     .replace('<style name>', this.convertScenarioToStyle(scenario))
            //     .replace('<List of 2 hardest objectives Achieved>', this.getBottomAdjectives(successObjectives, 2, undefined))
            //     .replace('<list of 3 easiest unachieved objectives>', this.getTopAdjectives(failedObjectives, 3, undefined))
            //     .replace('<Statement of how to achieve style which is also the plan>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 1))
            //     .replace('<Statement about style when you fail>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 5))
            //     .replace('<Statement about learner growth from this unsuccessful experience>', this.getSectionFromSheet2(configStatement, this.convertScenarioToX(scenario), 6));


        return {
            score: final,
            message_success: message,
            message_fail: message,
            style: this.convertScenarioToStyle(scenario)
        }
    }

    renderSimulatedSectionConfig = (config: any) => {
        const pass = parseFloat(config.score) >= 65.0;

        const message = pass ? config.message_success : config.message_fail;

        return <div>
            {message}
        </div>
    }

    convertTitleToShorthand = (title: string) => {
        if (title === 'Directive Style')     return 'directive';
        if (title === 'Delegative Style')    return 'delegative';
        if (title === 'Participative Style') return 'participative';

        return 'transformational';
    }

    getCurrentShorthand = () => {
        const {
            title
        } = this.props;

        return this.convertTitleToShorthand(title);
    }

    processExtraScenarios = (gameID: string) => {

    }

    interpExtraScenarios = (a1, a2, a3, s1, config, configStatement) => {
        this.setState({
            constructiveData: {
                a1, a2, a3, s1, config, configStatement
            },
            loadingConstructive: false
        });
    }

    renderConstructiveFeedback = () => {
        const {
            constructiveData,
            loadingConstructive
        } = this.state;

        let innards = <Spinner />

        if (loadingConstructive === false) {
            const scenario = this.props.selectedGame.scenario;
            const section = this.renderSimulatedSection(constructiveData.coaching[scenario], scenario);

            innards = <span>
                {this.renderSimulatedSectionConfig(section)}
            </span>
        }

        return <span style={{flexGrow: 1, flexBasis: 0, width: '100% !important'}}>
            <span style={{flexShrink: 1, transition: 'all 2s'}}>
                <span style={{position: 'relative'}}>
                    {innards}
                </span>
            </span>
        </span>
    }

    // Build a coached failure message
    renderNoSuccessMessage = () => {
        const achievedStyle = this.getHighestStyle();
        const goalStyle     = this.getCurrentShorthand().toLowerCase();

        // transformational isn't really a normal goal
        if (goalStyle === 'transformational') {
            return `That approach was most closely matched to (${achievedStyle})`;
        }

        return `That approach was more (${achievedStyle}) than ${goalStyle}`;
    }

    renderYourStyle = () => {
        if (this.state.loadingConstructive) return <span></span>        

        if (this.getIsIntendedStyleMatching() === false) {
            return <span style={{display: 'block', marginTop: '15px', marginBottom: '15px'}}>
                <H2 style={{textAlign: 'center', marginBottom: '20px', color: ''}}>{this.renderNoSuccessMessage()}</H2>
            </span>
        }

        const highestStyle = this.getHighestStyle();

        return <span style={{display: 'block', marginTop: '15px', marginBottom: '15px'}}>
            <H4 style={{textAlign: 'center'}}>Your achieved style</H4>
            <H2 style={{textAlign: 'center', marginBottom: '20px'}}>{highestStyle + " (" + this.getHighestScore().toString() + "%)"}</H2>
        </span>
    }

	render() {
        return <span style={{width: '100%'}}>
            {this.renderCardToRollover()}
            {this.renderYourStyle()}
            {this.renderConstructiveFeedback()}
        </span>
	}
}
